import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFinance } from '../store/slices/financeSlice';

export const useFinance = (startDate, endDate) => {
    const dispatch = useDispatch();
    const { loading } = useSelector(state => state.finance);
    const [financialData, setFinancialData] = useState({});
    const selectedBranch = useSelector((state) => state.branches.selectedBranch);

    useEffect(() => {
        if (!startDate || !endDate) {
            setFinancialData({});
            return;
        }

        const fetchFinanceData = async () => {
            try {
                const result = await dispatch(getFinance({
                    startDate: startDate.format('YYYY-MM-DD'),
                    endDate: endDate.format('YYYY-MM-DD'),
                    branchId: selectedBranch?.id
                })).unwrap();
                setFinancialData(result || {});
            } catch (error) {
                console.error('Finance verisi alınırken hata:', error);
                setFinancialData({});
            }
        };

        fetchFinanceData();
    }, [startDate, endDate, dispatch]);

    const refetchFinance = async () => {
        if (!startDate || !endDate) return;

        try {
            const result = await dispatch(getFinance({
                startDate: startDate.format('YYYY-MM-DD'),
                endDate: endDate.format('YYYY-MM-DD')
            })).unwrap();
            setFinancialData(result || {});
        } catch (error) {
            console.error('Finance verisi yenilenirken hata:', error);
            setFinancialData({});
        }
    };

    return {
        financialData,
        loading,
        refetchFinance
    };
}; 